<template>
  <div class="task-table">
    <div class="task-table__head">
      <div>Заголовок</div>
      <div>Автор</div>
      <div>Исполнитель</div>
      <input-sort
        v-model="sortByCreatedAt"
        v-on:input="sortTaskListByCreatedAt"
        name="createdAt"
      >
        <div
          class="task-table__head__cell sort"
          :class="[
            sortByCreatedAt === 'asc' ? 'sort--asc' : 'sort--desc',
            { selected: sortByCreatedAt },
          ]"
        >Дата создания</div>
      </input-sort>
      <input-sort
        v-model="sortByDeadline"
        v-on:input="sortTaskListByDeadline"
        name="deadline"
      >
        <div
          class="task-table__head__cell sort"
          :class="[
            sortByDeadline === 'asc' ? 'sort--asc' : 'sort--desc',
            { selected: sortByDeadline },
          ]"
        >Дедлайн</div>
      </input-sort>
      <div>Статус</div>
    </div>
    <div v-if="!this.isTaskListEmpty && !this.isAwaitRequest">
      <div
        v-for="(task, key) in taskList"
        v-bind:key="key"
        v-bind:style="{ background: task.isOverdue ? '#FFECEC' : '' }"
        class="task-table__body"
      >
        <button
          v-if="task.isAccessable"
          type="button"
          v-on:click="showTask(task.id)"
          class="task-table__row"
        >
          <div data-label="Заголовок">{{ task.title }}</div>
          <div data-label="Автор">{{ task.authorName }}</div>
          <div data-label="Исполнитель">{{ task.performerName }}</div>
          <div data-label="Дата создания" :class="{ overdue: task.isOverdue }">{{ task.createdAt }}</div>
          <div data-label="Дедлайн" :class="{ overdue: task.isOverdue }">{{ task.deadLine }}</div>
        </button>
        <div
          v-else
          class="task-table__row"
        >
          <div data-label="Заголовок">{{ task.title }}</div>
          <div data-label="Автор">{{ task.authorName }}</div>
          <div data-label="Исполнитель">{{ task.performerName }}</div>
          <div data-label="Дата создания" :class="{ overdue: task.isOverdue }">{{ task.createdAt }}</div>
          <div data-label="Дедлайн" :class="{ overdue: task.isOverdue }">{{ task.deadLine }}</div>
        </div>
        <button
          v-if="task.isAccessable"
          data-label="Статус"
          type="button"
          class="task-table__status"
          v-bind:class="`status-${task.status}`"
          v-on:click="showContextMenu($event, task.id)"
        >
          {{ mapStatus(task.status) }}
        </button>
        <div
          data-label="Статус"
          class="task-table__status not-edit"
          v-bind:class="`status-${task.status}`"
          v-else
        >
          {{ mapStatus(task.status) }}
        </div>
      </div>
    </div>
    <div
      v-else-if="!isAwaitRequest"
      class="task-table__message"
    >
      Ничего не найдено
    </div>
    <context-menu-task-status
      v-bind:value="isContextMenuOpen"
      v-bind:position-x="offsetContextMenuX"
      v-bind:position-y="offsetContextMenuY"
      v-on:change-status="emitChangeStatus"
      v-on:input="contextMenuWasClosed"
    />
  </div>
</template>

<script>
import ContextMenuTaskStatus from '@/components/ContextMenuTaskStatus.vue';
import { mapStatus } from '@/storage/gateways/TaskGateway';
import InputSort from '@/components/InputSort.vue';

export default {
  name: 'TaskTable',
  components: { InputSort, ContextMenuTaskStatus },
  data() {
    return {
      isContextMenuOpen: false,
      offsetContextMenuX: null,
      offsetContextMenuY: null,
      contextTaskId: 0,
      sortByDeadline: '',
      sortByCreatedAt: '',
    };
  },
  computed: {
    /**
     * @description Является ли список задач пустым.
     * @returns {boolean}
     */
    isTaskListEmpty() {
      return !Object.keys(this.taskList).length;
    },
  },
  methods: {
    showTask(taskId) {
      this.$emit('show-task', taskId);
    },
    showContextMenu(event, taskId) {
      this.contextTaskId = taskId;
      this.offsetContextMenuX = event.pageX;
      this.offsetContextMenuY = event.pageY;
      this.isContextMenuOpen = true;
    },
    emitChangeStatus(status) {
      this.$emit('change-status', this.contextTaskId, status);
    },
    contextMenuWasClosed() {
      this.isContextMenuOpen = false;
      this.contextTaskId = 0;
    },
    mapStatus,
    /**
     * Сортировать список пациентов по номеру карты
     */
    sortTaskListByDeadline() {
      this.$emit('sort-task-list', {
        type: 'deadline',
        order: this.sortByDeadline,
      });
    },
    /**
     * Сортировать список пациентов по номеру карты
     */
    sortTaskListByCreatedAt() {
      this.$emit('sort-task-list', {
        type: 'createdAt',
        order: this.sortByCreatedAt,
      });
    },
  },
  props: {
    taskList: { type: Array, required: true },
    isAwaitRequest: { type: Boolean, required: true },
  },
};
</script>

<style scoped lang="scss">
.task-table {
  &__head,
  &__row,
  &__body {
    display: grid;
    grid-template-columns:
      minmax(100px, 1fr) minmax(200px, 300px) minmax(200px, 300px)
      160px 160px 160px;
    width: 100%;
    align-items: center;
    justify-items: left;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    div {
      padding: 12px 8px;
      text-align: left;
    }
    &__cell {
      &.sort {
        display: flex;
        align-items: center;
        column-gap: 5px;
        padding: 0;
        cursor: pointer;
        &:after {
          content: '';
          width: 10px;
          height: 10px;
          background-image: url("@/assets/img/checked/checked-grey.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
      &.sort--asc {
        &:after {
          transform: rotate(180deg);
        }
      }
      &.selected {
        color: var(--action-color);
      }
    }
  }
  &__body {
    grid-template-columns: 1fr 160px;
    text-align: left;
    border-bottom: 1px solid #eaeff3;
    &:hover {
      background: #eaeff3;
      .task-table__row {
        background: #eaeff3;
      }
    }
  }
  &__row {
    grid-template-columns:
      minmax(100px, 1fr) minmax(200px, 300px)
      minmax(200px, 300px) 160px 160px;
    div {
      padding: 12px 8px;
      text-align: left;
    }
    .overdue {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #EF474C;
    }
  }
  &__status {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    width: min(100%, 160px);
    height: 100%;
    background-image: url("@/assets/img/checked/arrow-top-blue.svg");
    background-size: 13px 13px;
    background-position: right 10px center;
    padding: 0 0 0 14px;
    &.not-edit {
      background-image: none;
    }
    &.status-work {
      background-color: #F3FFE4;
    }
    &.status-completed {
      background-color: #E4FFEC;
    }
    &.status-canceled {
      background-color: #FFECEC;
    }
    &:before {
      content:'';
      height: 20px;
      margin-right: 10px;
      width: 20px;
    }
    &.status-new:before {
      background-color: #abb1a3;
      border-radius: 50%;
      content: "";
      height: 6px;
      width: 6px;
      margin-right: 10px;
    }
    &.status-work:before {
      background-image: url("@/assets/img/status/cheked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
      height: 15px;
      width: 15px;
    }
    &.status-completed:before {
      background-image: url("@/assets/img/checked/all-checked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
    }
    &.status-canceled:before {
      background-image: url("@/assets/img/exit-red.svg");
      min-width: 20px;
      min-height: 20px;
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
}
@media screen and (max-width: 1300px) {
  .task-table {
    &__head {
      grid-template-columns: 1fr 150px 150px 100px 100px 130px;
    }
    &__body {
      grid-template-columns: 1fr 130px;
      &:hover {
        background: #eaeff3;
        .task-table__row {
          background: #eaeff3;
        }
      }
    }
    &__row {
      grid-template-columns: 1fr 150px 150px 100px 100px;
      .overdue {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #EF474C;
      }
    }
  }
}
@media screen and (max-width: 860px) {
  .task-table {
    &__head {
      display: none;
    }
    &__body {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
      padding: 0 0 20px 0;
      button:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
      }
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      justify-items: stretch;
      div {
        display: flex;
        justify-content: space-between;
        text-align: right;
      }
      div:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
      }
      .overdue {
        justify-content: space-between;
        &:before {
          content: attr(data-label);
          background-image: none;
          width: initial;
          height: initial;
          margin: 0 20px 0 0;
        }
      }
    }
    &__status {
      width: 100%;
      padding: 12px 40px 12px 8px;
      background-size: 15px 15px;
      justify-content: space-between;
      &:before {
        height: initial;
        margin-right: initial;
        width: initial;
      }
      &.status-new:before,
      &.status-work:before,
      &.status-completed:before,
      &.status-canceled:before {
        content: attr(data-label);
        background-image: none;
        height: initial;
        width: initial;
        margin: 0 20px 0 0;
        background-color: transparent;
      }
    }
  }

}

</style>
